module.exports = __webpack_public_path__ + "static/img/14010113.ffc1bcb0.png";